import {
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { ErrorMonitoring } from 'core/common/services/errorMonitoring';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { AxonService } from '../../interfaces';
import { AxonServiceWithMonitoring } from './AxonServiceWithMonitoring';

export class AxonServiceBuilder {
  constructor(private axonService: AxonService) {}

  addMonitoring(
    observabilitySystem: ObservabilitySystem,
    errorMonitoringService: ErrorMonitoring,
    funnelSettingsService: FunnelSettingsServiceInterface,
  ): this {
    const provideAdditionalObservabilityAttributes = () => {
      return {
        [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
        [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
      };
    };

    this.axonService = new AxonServiceWithMonitoring(
      this.axonService,
      observabilitySystem,
      errorMonitoringService,
      provideAdditionalObservabilityAttributes,
    );

    return this;
  }

  getResult(): AxonService {
    return this.axonService;
  }
}
